import {HandlerProps} from './types'

type UseDragHandlersRet = {
  dragEnter: () => void
  dragStart: () => void
  dragEnd: () => void
}

export const useDragHandlers = (props: HandlerProps): UseDragHandlersRet => {
  const {stringStickerState, store} = props
  const dragEnter = (): void => {
    store.stringStateDragEnter(stringStickerState)
  }
  const dragStart = (): void => store.stringStateDragStart(stringStickerState)
  const dragEnd = (): void => store.stringStateDragEnd()

  return {dragEnter, dragStart, dragEnd}
}
